import { TradingOffer, TradingOfferType } from 'types/TradingOffer';

export const filterSellOffers = (offers: TradingOffer[]): TradingOffer[] =>
  offers.filter((offer) => offer.type === TradingOfferType.SELL);

export const filterBuyOffers = (offers: TradingOffer[]): TradingOffer[] =>
  offers.filter((offer) => offer.type === TradingOfferType.BUY);
